import { ElectricityIcon } from "@/public/icons/ElectricityIcon";
import styles from "./Category.module.scss";

export type CategoryProps = {
  title: string;
  subTitle: string;
};

export const Category = ({ title, subTitle }: CategoryProps) => {
  return (
    <div className={styles.category}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.subTitleContainer}>
        {subTitle && (
          <p className={styles.subTitle}>
            <ElectricityIcon />
            {subTitle}
          </p>
        )}
      </div>
    </div>
  );
};
